/**
 * Runtime Environment
 *
 * Platform-agnostic exports for runtime setup.
 * Automatically detects browser vs Node.js environment.
 */

export type { RuntimeEnv } from './RuntimeEnv';

// Re-export platform-specific modules
// Consumers should import from the specific module they need:
//   import { getWebEnv } from '@/runtime/env/web'
//   import { getNodeEnv } from '@/runtime/env/node'

// Environment detection
export const isBrowser = typeof window !== 'undefined' && typeof window.document !== 'undefined';
export const isNode = !isBrowser;

/**
 * Get the runtime environment for the current platform.
 * Use this for platform-agnostic code.
 */
export async function getEnv() {
  if (isBrowser) {
    const { getWebEnv } = await import('./web');
    return getWebEnv();
  } else {
    const { getNodeEnv } = await import('./node');
    return getNodeEnv();
  }
}

/**
 * Close the audio context for the current platform.
 */
export async function closeAudioContext() {
  if (isBrowser) {
    const { closeWebAudioContext } = await import('./web');
    return closeWebAudioContext();
  } else {
    const { closeNodeAudioContext } = await import('./node');
    return closeNodeAudioContext();
  }
}

